import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../service";
import {ICodeName as dictionaryInterface} from "../../models";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "./view-dictionary-base";

@Component({
  selector: 'app-dict-qref-typeoperator4936',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefTypeoperator4936ViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3 col-6 pl-0 pr-0">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['code','name']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          {{ item.name }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <div style="white-space: normal">
            {{ item.name }}
          </div>
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefTypeoperator4936ViewComponent extends ViewDictionaryBase<dictionaryInterface> {
  getDictionary = this.dictSrv.getQrefTypeoperator4936List();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
